import styled from "styled-components";

export const Inner = styled.div`
	display: flex;
	padding: 20px;
`;
